import { compose, withHandlers, withProps, withPropsOnChange, withState } from 'recompose';
import { connect } from 'react-redux';
import { isEqual, partial } from 'lodash';
import { bindActionCreators } from 'redux';

import { addBarber, updateBarber, deleteBarber, resetBarber } from '../../../actions/brand';
import { saveBarberImage } from '../../../actions';
import { isEditingExistingBarber } from '../helpers/isEditMode';
import withLocationSelectorState from './withLocationSelectorState';
import withSelectedLocationsState from './withSelectedLocationsState';
import {
  getDefaultBarberLocationInitialValues,
  getBarbersDataForEdit,
  applyAllToSpecificLocation,
  getAllLocationsBarberValues,
} from '../helpers/formValuesHelpers';
import { LOCATIONS_ALL_ID } from '../constants';

const withModel = compose(
  withLocationSelectorState,
  withSelectedLocationsState,
  withState('errors', 'setErrors', null),
  connect(
    (state, ownProps) => ({
      barberLocationData: getBarbersDataForEdit(state, ownProps.brandShops),
    }),
    (dispatch, ownProps) =>
      bindActionCreators({
        saveBarber: partial(addBarber, ownProps.brandId),
        modifyBarber: partial(updateBarber, ownProps.brandId),
        removeBarber: partial(deleteBarber, ownProps.brandId),
        resetBarber,
        saveBarberImage,
      }, dispatch)
  ),
  withProps(() => ({ useShopServices: false })),
  withPropsOnChange(['barberLocationData'], props => ({
    initialValues: isEditingExistingBarber(props)
      ? props.barberLocationData
      : { [LOCATIONS_ALL_ID]: getDefaultBarberLocationInitialValues(props) },
  })),
  withHandlers({
    onSelectedLocationChange: props => (evt) => {
      const newSelectedLocation = evt.target.value;
      props.setSelectedLocation(newSelectedLocation);
    },
  }),
  // When something changes on 'All locations' view, update each location
  withPropsOnChange((prevProps, nextProps) => (prevProps.formValues
    && nextProps.formValues
    && prevProps.selectedLocation === LOCATIONS_ALL_ID
    && nextProps.selectedLocation === LOCATIONS_ALL_ID
    && !isEqual(prevProps.formValues[LOCATIONS_ALL_ID], nextProps.formValues[LOCATIONS_ALL_ID])
  ),
  (props) => {
    if (!props.formValues || !props.formValues[LOCATIONS_ALL_ID]) {
      return;
    }

    Object.keys(props.formValues).forEach((locationId) => {
      if (locationId !== LOCATIONS_ALL_ID) {
        const updatedLocationData = applyAllToSpecificLocation(props.formValues, locationId);
        props.change(locationId, updatedLocationData);
      }
    });
  }),
  // When something changes on a specific location view, update 'All locations'
  withPropsOnChange((prevProps, nextProps) => (prevProps.formValues
    && nextProps.formValues
    && !!nextProps.formValues[LOCATIONS_ALL_ID]
    && prevProps.selectedLocation === nextProps.selectedLocation
    && (prevProps.selectedLocation !== LOCATIONS_ALL_ID || (prevProps.isServicesTab && nextProps.isServicesTab))
    && !!nextProps.selectedLocation
    && nextProps.formValues[LOCATIONS_ALL_ID] === prevProps.formValues[LOCATIONS_ALL_ID]
    && Object.keys(nextProps.formValues).filter(key => key !== LOCATIONS_ALL_ID).some(
      key => prevProps.formValues[key] !== nextProps.formValues[key]
    )
  ),
  (props) => {
    if (!props.formValues || !props.formValues[LOCATIONS_ALL_ID]) {
      return;
    }

    const recalculatedAll = getAllLocationsBarberValues(props.formValues);
    props.change(LOCATIONS_ALL_ID, recalculatedAll);
  }),
);

export default withModel;
